export default "__VITE_ASSET__a41767e6__"